export const riskThresholds = {
  low: 0,
  medium: 0.3,
  high: 0.5
};



// WEBPACK FOOTER //
// ./src/constants/cpd-progress.js